<template>
  <span :class="['price-pair', `price-pair--${layout}`]">
    <InternalAmount
      v-if="showInternalAmount"
      :amount="internalAmountValue"
      class="price-pair__internal"
    />
    <span v-if="showFiatAmount" class="price-pair__fiat">{{ formattedFiat }}</span>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import InternalAmount from './InternalAmount.vue'

export default {
  name: 'PricePair',
  components: {
    InternalAmount
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    fiatAmount: {
      type: [Number, String],
      default: null
    },
    internalAmount: {
      type: [Number, String],
      default: null
    },
    fiatCurrency: {
      type: String,
      default: null
    },
    layout: {
      type: String,
      default: 'stack'
    },
    showFiatWhenInternal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('app', ['currency', 'currencySymbol', 'internalCurrencyEnabled']),
    fiatAmountValue() {
      const value = this.fiatAmount ?? this.item?.fiat_price ?? this.item?.price ?? 0
      return Number(value || 0)
    },
    internalAmountValue() {
      const value = this.internalAmount ?? this.item?.internal_price

      if (value !== undefined && value !== null) {
        return Number(value || 0)
      }

      return null
    },
    showInternalAmount() {
      return this.internalCurrencyEnabled && this.internalAmountValue !== null
    },
    showFiatAmount() {
      return !this.showInternalAmount || this.showFiatWhenInternal
    },
    formattedFiatAmount() {
      return this.fiatAmountValue.toFixed(2)
    },
    formattedFiat() {
      if (this.fiatCurrency) {
        return `${this.formattedFiatAmount} ${this.fiatCurrency}`
      }

      return `${this.currencySymbol || this.currency} ${this.formattedFiatAmount}`
    }
  }
}
</script>

<style scoped>
.price-pair {
  display: inline-flex;
  gap: 5px;
  text-align: left;
  vertical-align: middle;
}

.price-pair--stack {
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.15;
}

.price-pair--inline {
  flex-direction: row;
  align-items: center;
}

.price-pair__internal {
  font-weight: 700;
  align-items: center;
}

.price-pair__fiat {
  color: rgba(32, 32, 32, 0.62);
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
</style>
